"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Pen: function() {
        return Pen;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Pen = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M20.7929 3.20709C20.355 2.76919 19.645 2.76919 19.2071 3.20709L17.9142 4.49998L19.5 6.08577L20.7929 4.79287C21.2308 4.35497 21.2308 3.64499 20.7929 3.20709ZM22.2071 1.79288C23.4261 3.01183 23.4261 4.98814 22.2071 6.20709L20.2071 8.20709L7.88227 20.5319C6.98516 21.4291 5.8611 22.0655 4.63027 22.3732L2.24256 22.9701C1.90178 23.0553 1.54129 22.9555 1.29291 22.7071C1.04453 22.4587 0.944685 22.0982 1.02988 21.7574L1.62681 19.3697C1.93451 18.1389 2.57095 17.0148 3.46806 16.1177L15.7929 3.79288L17.7929 1.79288C19.0119 0.573925 20.9882 0.573924 22.2071 1.79288ZM16.5 5.9142L4.88227 17.5319C4.24148 18.1727 3.78688 18.9756 3.56709 19.8548L3.37439 20.6256L4.1452 20.4329C5.02436 20.2131 5.82726 19.7585 6.46806 19.1177L18.0858 7.49998L16.5 5.9142Z",
        fill: "currentColor"
    })
}), "Pen");
const _default = Pen;
